import { getLogoInfo, uploadLogo, setLogo } from '@/services/config'

const store = {
  namespaced: true,
  state: {
    loadContent: true,
    uploading: false
  },
  mutations: {
    setLoadContent (state, load) {
      state.loadContent = load
    },
    SET_UPLOADIG (state, load) {
      state.uploading = load
    }
  },
  actions: {
    async getLogoInitInfo ({ commit }) {
      commit('setLoadContent', true)
      commit('SET_UPLOADIG', true)
      const chain = await getLogoInfo()
        .onNetComplete(() => {
          commit('setLoadContent', false)
          commit('SET_UPLOADIG', false)
        })
        .config({ tip: false })
      return chain
    },
    async uploadNewLogo ({ commit }) {
      commit('SET_UPLOADIG', true)
      const chain = await uploadLogo()
        .onNetComplete(() => {
        })
        .config({ tip: false })
      return chain
    },
    async setProjectLogo ({ commit }, params) {
      const chain = await setLogo()
        .params(params)
        .onNetComplete(() => {
          commit('SET_UPLOADIG', false)
        })
        .config({ tip: true })
      return chain
    },
    async setMobileProjectLogo ({ commit }, params) {
      const chain = await setLogo()
        .params(params)
        .onNetComplete(() => {
        })
        .config({ tip: false })
      return chain
    }
  }
}

export default store
